export default __webpack_public_path__ + "static/media/campaignImg.d5140f78.jpg";